import script from "./ImportBookingsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportBookingsButton.vue?vue&type=script&setup=true&lang=ts"

import "./ImportBookingsButton.vue?vue&type=style&index=0&id=45c25fd0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45c25fd0"]])

export default __exports__